/**
 * Convert an array of objects to CSV and trigger download.
 * @param {Array<Object>} data - rows
 * @param {string} filename - e.g. "risk_report.csv"
 * @param {Array<{key:string, label:string}>} columns - ordered column definitions
 */
export function exportCsv(data, filename, columns) {
  if (!data || !data.length) return;

  const header = columns.map(c => `"${c.label}"`).join(',');

  const rows = data.map(row =>
    columns
      .map(c => {
        let val = row[c.key];
        if (val === null || val === undefined) val = '';
        val = String(val).replace(/"/g, '""');
        return `"${val}"`;
      })
      .join(',')
  );

  const csv = [header, ...rows].join('\r\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
